import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }

  static getDerivedStateFromError() {
    return { error: true };
  }

  componentDidCatch(err) {
    console.error('Render error:', err);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink px-6 text-center">
          <div>
            <p className="font-display text-2xl font-bold text-white">Something went wrong.</p>
            <button
              data-testid="error-reload-button"
              onClick={() => window.location.reload()}
              className="mt-4 rounded-full bg-pulse px-6 py-2 font-semibold text-ink"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
